import React from 'react';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';
import { FormButtons, FormRow, Map } from '../controls';

const VendorSchema = Yup.object().shape({
  vendor: Yup.object().required('Vendor is required'),
});

export const FestivalVendorForm = ({
  vendor,
  vendors,
  handleSave,
  handleRemove,
  onLocationChange,
}) => {
  const defaultValues = {
    description: vendor.description || '',
    vendor: vendor.vendor || {},
    vendorId: vendor.vendor?.vendorId ?? '',
  };

  const submit = (vals) => {
    const { vendorId: _id, ...rest } = vals;
    handleSave(rest);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={submit}
      validationSchema={VendorSchema}
    >
      {() => (
        <Form>
          <FormRow label="Vendor" errorName="vendor">
            <Field
              name="vendorId"
              render={({ form: { setFieldValue, values } }) => (
                <select
                  className="h-10 w-full rounded-[20px] border border-[var(--festy-input-border)] px-4 outline-none"
                  value={values.vendorId === '' ? '' : String(values.vendorId)}
                  onChange={(e) => {
                    const id = e.target.value;
                    if (!id) {
                      setFieldValue('vendor', {});
                      setFieldValue('vendorId', '');
                      return;
                    }
                    const found = vendors.find(
                      (x) => String(x.vendorId) === String(id),
                    );
                    setFieldValue('vendor', found || {});
                    setFieldValue('vendorId', found?.vendorId ?? '');
                  }}
                >
                  <option value="">Select a vendor</option>
                  {vendors.map((v) => (
                    <option key={v.vendorId} value={String(v.vendorId)}>
                      {v.vendorName}
                    </option>
                  ))}
                </select>
              )}
            />
          </FormRow>
          <FormRow label="Description">
            <Field
              component="textarea"
              name="description"
              placeholder="Festival Specific Vendor Description..."
            />
          </FormRow>
          <FormRow>
            <Map location={vendor.location} handleClick={onLocationChange} />
          </FormRow>
          <FormButtons
            showDelete={vendor.vendorId}
            title="Vendor"
            onDelete={handleRemove}
          />
        </Form>
      )}
    </Formik>
  );
};
